import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "@/context/AuthContext";
import { BranchProvider } from "@/context/BranchContext";
import { ThemeProvider } from "@/context/ThemeContext";
import SeoManager from "@/components/feature/SeoManager";
import AppErrorBoundary from "@/components/feature/AppErrorBoundary";
import ConnectionStatus from "@/components/feature/ConnectionStatus";


function App() {
  return (
    <AppErrorBoundary>
      <I18nextProvider i18n={i18n}>
        <AuthProvider>
          <BranchProvider>
            <ThemeProvider>
              <BrowserRouter basename={__BASE_PATH__}>
                <SeoManager />
                <ConnectionStatus />
                <AppRoutes />
              </BrowserRouter>
            </ThemeProvider>
          </BranchProvider>
        </AuthProvider>
      </I18nextProvider>
    </AppErrorBoundary>
  );
}

export default App;